import { Howler } from 'howler';

const getAudioVendor = () => Howler;

const handleSettingChangeSubscription = (setting, newValue) => {
  switch (setting) {
    case 'muteSounds': {
      Howler.mute(newValue);
      break;
    }
    case 'volume': {
      Howler.volume(newValue / 100);
      break;
    }
  }
};

const getElementId = element => Number(element?.children[0]?.id.split('-')[1]);

export { getAudioVendor, handleSettingChangeSubscription, getElementId };
